/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type OpenSecuritiesAccountRequestPaymentPayMethod = typeof OpenSecuritiesAccountRequestPaymentPayMethod[keyof typeof OpenSecuritiesAccountRequestPaymentPayMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OpenSecuritiesAccountRequestPaymentPayMethod = {
  ACCOUNT_BALANCE: 'ACCOUNT_BALANCE',
} as const;
